var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPreviewGrey1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#7c7c7c;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M264.2,346.8c-35.3,0-59.2-9.6-80.1-27.1c-10-8.4-18.5-18.1-27-27.9c-0.8-0.9-0.6-1.4,0.2-2.1 c5-4.3,10-8.5,14.9-12.9c1.2-1.1,1.7-0.4,2.5,0.4c6.4,7.4,12.8,14.9,20,21.7c13.2,12.4,28.3,21.2,46.5,24 c28.7,4.4,54-3.1,75.5-22.8c10.8-9.9,19.9-21.4,29-32.8c2.7-3.4,5.4-6.8,8.2-10.1c0.7-0.8,0.9-1.3,0.1-2.2 c-11.6-13.8-22-28.5-35.1-41c-12.6-12-27-21-44.3-24.3c-28.3-5.4-53.8,0.9-75.8,19.8c-12.1,10.4-21.9,22.9-31.8,35.3 c-7,8.8-14.3,17.4-22,25.6c-1.4,1.5-2.1,1.3-3.4,0c-4.4-4.2-8.9-8.3-13.4-12.5c-0.8-0.7-1.6-1.2-0.4-2.5 c12.8-12.9,23.1-27.8,34.9-41.5c11.3-13.2,23.8-25.1,38.9-34c20.8-12.2,43.3-16.6,67.2-14.1c27.7,2.9,50.2,16.1,69.6,35.3 c10.8,10.8,20.2,22.8,29.6,34.8c5.1,6.5,10.5,12.7,16.2,18.7c0.8,0.9,1.3,1.4,0.2,2.5c-11.2,11.4-20.5,24.4-30.7,36.7 c-12.1,14.6-25.3,28-41.8,37.8C294.7,341.9,276.2,346.8,264.2,346.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M256.4,210.6c-25.1-0.1-45.5,20.3-45.5,45.4c0,25,20.3,45.3,45.2,45.4c25,0.1,45.5-20.3,45.5-45.4 C301.6,231,281.4,210.7,256.4,210.6z M256.4,278.7c-12.6,0.1-22.9-10.1-22.9-22.7c0-12.6,10.2-22.9,22.8-22.8 C269,233.4,279,243.4,279,256C279.1,268.5,269,278.6,256.4,278.7z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M256,6C117.9,6,6,117.9,6,256s111.9,250,250,250s250-111.9,250-250S394.1,6,256,6z M256,492.5 C125.4,492.5,19.5,386.6,19.5,256S125.4,19.5,256,19.5S492.5,125.4,492.5,256S386.6,492.5,256,492.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPreviewGrey1);
export default __webpack_public_path__ + "static/media/icon-preview-grey-1.6222f51b9804a26b03558c14c53db04c.svg";
export { ForwardRef as ReactComponent };